import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorBase } from '@shared/bases/control-value-accessor.base';
import { SharedModule } from '@shared/modules/shared.module';
import { ChipComponent } from '../chip/chip.component';

@Component({
	selector: 'app-chips-input',
	imports: [SharedModule, ChipComponent],
	templateUrl: './chips-input.component.html',
	styleUrl: './chips-input.component.scss',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ChipsInputComponent),
			multi: true,
		},
	],
})
export class ChipsInputComponent extends ControlValueAccessorBase<string[]> {
	@Input() placeholder?: string;
	@Input() label?: string;
	@Input() disabled = false;
	@Input() error = false;
	@Input() errorMessage = '';
	@Input() size: 'large' | 'medium' | 'small' = 'large';

	@Output() chipsChange = new EventEmitter<string[]>();

	chipsInputId = `chips-input-${Math.random().toString(36).substring(2, 11)}`;
	currentChip = '';

	get chipSize(): 'small' | 'large' {
		return this.size === 'small' ? 'small' : 'large';
	}

	/** 🔹 Handles chip addition */
	addChip(event: KeyboardEvent, inputValue: string): void {
		const value = inputValue.trim();

		if (event.key === 'Enter' && value) {
			event.preventDefault();
			this.value = [...(this.value || []), value];
			this.notifyValueChange(this.value);
			this.chipsChange.emit(this.value);
			this.currentChip = '';
		}
	}

	/** 🔹 Removes a chip */
	removeChip(index: number): void {
		this.value = (this.value || []).filter((_, i) => i !== index);
		this.notifyValueChange(this.value);
		this.chipsChange.emit(this.value);
	}

	onInputChange(event: Event): void {
		const input = event.target as HTMLInputElement;
		this.currentChip = input.value;
	}

	handleKeydown(event: KeyboardEvent): void {
		const input = event.target as HTMLInputElement;
		this.addChip(event, input.value);
	}
}
